export const RouteNames = {
  Home: 'home',
  MaterialMine: 'material-mine',
  MaterialList: 'material-list',
  MaterialListRoot: 'material-list-root',
  Demo: 'demo',
  NormalExamDetail: 'normal-exam-detail',
  ImitateExamDetail: 'imitate-exam-detail',
  PreviousExamDetail: 'previous-exam-detail',
  ExamAnswer: 'exam-answer',
  ExamResult: 'exam-result',
  ExamAnalyze: 'exam-analyze',
  ExamReview: 'exam-review',
  ChapterList: 'chapter-list',
  ChapterListRoot: 'chapter-list-root',
  chapterKnowledge: 'chapter-knowledge',
  chapterKnowledgeRoot: 'chapter-knowledge-root',
  ChapterYears: 'chapter-years',
  ChapterYearsRoot: 'chapter-years-root',
  ChapterImitate: 'chapter-imitate',
  ChapterImitateRoot: 'chapter-imitate-root',
  UserCenter: 'user-center',
  UserAnswerRecord: 'user-answer-record',
  UserCollection: 'user-collection',
  UserWrong: 'user-wrong',
  UserCorrection: 'user-correction',
  UserAppSubjectName: 'user-app-subject-name',
};

export const routeCnNames = {
  [RouteNames.MaterialMine]: '我的资料',
  [RouteNames.MaterialListRoot]: '组团领资料',
  [RouteNames.MaterialList]: '组团领资料',
  [RouteNames.ChapterListRoot]: '章节练习',
  [RouteNames.ChapterList]: '章节练习',
  [RouteNames.chapterKnowledge]: '知识点练习',
  [RouteNames.chapterKnowledgeRoot]: '知识点练习',
  [RouteNames.ChapterYearsRoot]: '历年试题',
  [RouteNames.ChapterYears]: '历年试题',
  [RouteNames.ChapterImitateRoot]: '模拟考场',
  [RouteNames.ChapterImitate]: '模拟考场',
  [RouteNames.UserCenter]: '个人中心',
  [RouteNames.UserAnswerRecord]: '做题历史',
  [RouteNames.UserCollection]: '收藏夹',
  [RouteNames.UserWrong]: '错题集',
  [RouteNames.UserCorrection]: '我的纠错',
  [RouteNames.UserAppSubjectName]: '我的题库',
};
